import createAxios from 'config/axios'

const URL = '/schrodinger/featureToggle'
const getFeatureToggle = () => createAxios.get(URL)

export default getFeatureToggle
